module.exports = __webpack_public_path__ + "img/projects_nadvorie.82474be2.jpg";